'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForkIcon = function ForkIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M12 26.313c0-.5-.188-.938-.5-1.25s-.75-.5-1.188-.5c-.5 0-.938.188-1.25.5s-.5.75-.5 1.25c0 .438.188.875.5 1.188s.75.5 1.25.5A1.71 1.71 0 0 0 12 26.313zm0-20.625A1.71 1.71 0 0 0 10.312 4c-.5 0-.938.188-1.25.5s-.5.75-.5 1.188c0 .5.188.938.5 1.25s.75.5 1.25.5c.438 0 .875-.188 1.188-.5s.5-.75.5-1.25zM23.438 8c0-.5-.188-.875-.5-1.188-.313-.375-.75-.5-1.25-.5-.438 0-.875.125-1.188.5-.313.313-.5.688-.5 1.188s.188.875.5 1.188c.313.375.75.5 1.188.5.5 0 .938-.125 1.25-.5a1.6 1.6 0 0 0 .5-1.188zm1.687 0c0 .625-.125 1.188-.438 1.75-.313.5-.75.938-1.25 1.188-.063 3.438-1.375 5.938-4.063 7.438-.813.438-2 .938-3.625 1.438-1.5.438-2.5.875-3 1.25s-.75 1-.75 1.813v.438c.5.313.938.75 1.25 1.25s.438 1.125.438 1.75c0 .938-.313 1.75-1 2.375-.625.688-1.438 1-2.375 1-1 0-1.813-.313-2.438-1-.688-.625-1-1.438-1-2.375 0-.625.125-1.25.438-1.75s.75-.938 1.25-1.25V8.69c-.5-.313-.938-.75-1.25-1.25s-.438-1.125-.438-1.75c0-.938.313-1.75 1-2.375.625-.688 1.438-1 2.438-1 .938 0 1.75.313 2.375 1 .688.625 1 1.438 1 2.375 0 .625-.125 1.25-.438 1.75s-.75.938-1.25 1.25v8.875c.625-.313 1.563-.688 2.75-1 .625-.25 1.188-.375 1.563-.563a7.07 7.07 0 0 0 1.25-.563c.438-.188.813-.438 1.063-.688s.5-.563.75-.938c.188-.313.375-.75.5-1.188.063-.5.125-1.063.125-1.688-.5-.25-.938-.688-1.25-1.188a3.464 3.464 0 0 1-.438-1.75c0-.938.313-1.75 1-2.438.625-.688 1.438-1 2.375-1 1 0 1.813.313 2.438 1 .688.688 1 1.5 1 2.438z' })
    );
};

exports.default = ForkIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/ForkIcon.js
// module id = 634
// module chunks = 0